import PartnerCard from './PartnerCard';

export default PartnerCard;
